var render = function render(){var _vm=this,_c=_vm._self._c;return _c('file-pond',{ref:"fpond",attrs:{"name":_vm.name,"label-idle":_vm.$t('click or drop files here'),"allow-multiple":_vm.allow_multiple,"allow-revert":_vm.allow_revert,"server":{
    url: _vm.api_host,
    timeout: _vm.enterprise_setup.upload_timeout,
    process: {
      url: _vm.url,
      method: 'POST',
      headers: {
        'x-access-token': _vm.token_session,
      },
      withCredentials: false,
    },
  }},on:{"error":_vm.filepond_error,"processfile":_vm.filepond_process}})
}
var staticRenderFns = []

export { render, staticRenderFns }